import Spinner from "components/Spinner";
import FindReportCustomerDropDowns from "./FindReportCustomerDropDowns";

export default function FindReportAdvanceSearchForm({
  showModal,
  formData,
  setFormData,
  loading,
  handleSearch,
  saveRequest,
}) {
  /*   All Functions
   ********************************************* */
  const handleInputChange = (event, type) => {
    const { name, value } = event.target;
    // let updatedValue = type === "number" ? parseInt(value) : value;
    // setFormData({ ...formData, [name]: updatedValue });

    let _value;
    if (type === "number") {
      _value = parseInt(value);
    } else if (type === "boolean") {
      _value = value === "true";
    } else {
      _value = value;
    }

    saveRequest(name, _value);
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      {loading && <Spinner />}

      <div className="">
        {/* <FindReportContactAndBilling
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
        /> */}

        <div className="row bg-white custom-border-radius-sm custom-shadow mx-1">
          <FindReportCustomerDropDowns
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          />
          {/* <FindReportCustomFields
            formData={formData}
            setFormData={setFormData}
            handleInputChange={handleInputChange}
          /> */}
        </div>
      </div>
      <div className="d-flex justify-content-end mt-3 gap-1">
        <button
          onClick={() => {
            showModal(false);
          }}
          className="btn btn-secondary"
        >
          Close
        </button>

        <button onClick={handleSearch} className="btn btn-success">
          Search
        </button>
      </div>
    </div>
  );
}
